"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreExternalAccountPurposeEnum = void 0;
/**
 * Назначение (тип) внешнего счёта
 */
var BillingCoreExternalAccountPurposeEnum;
(function (BillingCoreExternalAccountPurposeEnum) {
  /** Для оплат */
  BillingCoreExternalAccountPurposeEnum["PAYMENT"] = "PAYMENT";
  /** Для выплат */
  BillingCoreExternalAccountPurposeEnum["PAYOUT"] = "PAYOUT";
  /** Для оплат и выплат */
  BillingCoreExternalAccountPurposeEnum["PAYMENT_PAYOUT"] = "PAYMENT_PAYOUT";
})(BillingCoreExternalAccountPurposeEnum = exports.BillingCoreExternalAccountPurposeEnum || (exports.BillingCoreExternalAccountPurposeEnum = {}));
